import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full px-4 py-20 bg-ivory" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-cream border-2 border-sage/20 rounded-3xl p-8 md:p-12 text-center shadow-[0_20px_60px_-30px_rgba(92,107,79,0.35)]" data-id="element-106">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-sage/10 mb-6" data-id="element-107">
            <ShieldCheck className="w-10 h-10 text-sage" data-id="element-108" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif text-ink mb-6 leading-tight" data-id="element-109">
            Pruébala 7 días. Si no es para ti, te devolvemos tu dinero.
          </h2>
          <p className="text-lg text-ink/80 mb-6 leading-relaxed" data-id="element-110">
            Tienes 7 días completos para revisar la guía, aplicar las primeras
            recomendaciones y decidir. Si sientes que no es lo que necesitas,
            escríbenos y procesamos tu devolución sin preguntas incómodas. Tu
            tranquilidad va primero.
          </p>
          <p className="text-sm font-bold text-sage uppercase tracking-widest" data-id="element-111">
            🛡️ Garantía de satisfacción de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}